<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-0.41,797.95h1.82v-14.54l1.82,3.63l1.82,14.55h-9.09l1.82-14.55l1.82-3.63V797.95z M-9.5,801.59l2.73-5.46l1.82-1.82
	l-0.91,7.27H-9.5z M10.5,801.59l-2.73-5.46l-1.82-1.82l0.91,7.27H10.5z"/>
</svg>

</template>